import planCardStyles from '../pricing-plan-card/styles'

// Type, price and button colours come from the existing plan card so the
// creator and enterprise cards stay consistent.
const styles = theme => {
  const plan = planCardStyles(theme)
  return {
    root: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      borderRadius: 16,
      border: '1px solid #E5E7EB',
      backgroundColor: '#fff',
      overflow: 'hidden',
      boxShadow:
        '0 0 2px 0 rgba(145, 158, 171, 0.12), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
    },
    topBar: {
      height: 6,
      backgroundColor: '#015FFB',
    },
    body: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      padding: 32,
      '@media (max-width: 600px)': {
        padding: 24,
      },
    },
    header: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      gap: 16,
    },
    name: { ...plan.cardSubscription, marginBottom: 4 },
    // The part of the plan name that tells the two enterprise plans apart.
    nameHighlight: { color: '#015FFB' },
    // Creator cards: the tagline under the plan name, at the same size as the
    // enterprise description.
    caption: {
      ...plan.cardCaption,
      maxWidth: 220,
      fontSize: '14px',
      lineHeight: '160%',
      letterSpacing: 'normal',
    },
    captionWide: {
      ...plan.cardCaption,
      marginTop: 16,
      fontSize: '14px',
      lineHeight: '160%',
      letterSpacing: 'normal',
    },
    priceBlock: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      flexShrink: 0,
    },
    priceRow: { ...plan.priceRow, marginBottom: 0 },
    dollarSign: plan.dollarSign,
    priceValue: plan.priceValue,
    priceUnit: { ...plan.priceMonth, marginTop: 4, whiteSpace: 'nowrap' },
    savings: {
      ...plan.savingsText,
      marginTop: 4,
    },
    button: { ...plan.upgradeButton, marginTop: 28 },
    // Demo + upgrade side by side on the enterprise cards.
    ctaRow: {
      display: 'flex',
      gap: 12,
      '@media (max-width: 600px)': {
        flexDirection: 'column',
        gap: 8,
      },
    },
    demoButton: {
      marginTop: 28,
      borderRadius: 24,
      textTransform: 'none',
      fontFamily: 'Inter',
      fontWeight: 600,
      fontSize: '15px',
      '@media (max-width: 600px)': {
        marginTop: 0,
      },
    },
    switchButton: { marginTop: 28 },
    grid: {
      listStyle: 'none',
      padding: 0,
      margin: '32px 0 0',
      display: 'grid',
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
      gap: '28px 24px',
      '@media (max-width: 600px)': {
        gridTemplateColumns: '1fr',
      },
    },
    item: {
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
    },
    icon: {
      width: 24,
      height: 24,
      color: '#015FFB',
    },
    itemText: {
      ...plan.featureText,
      color: '#637381',
    },
    // Enterprise extras.
    // Badge above the plan name ("Standalone" / "Headless").
    useCase: {
      ...plan.cardCaption,
      alignSelf: 'flex-start',
      marginBottom: 12,
      padding: '5px 12px',
      borderRadius: 20,
      backgroundColor: '#E3F3FF',
      color: '#034894',
      fontSize: '12px',
      fontWeight: 700,
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
    },
    learners: {
      ...plan.savingsText,
      marginTop: 4,
      color: '#034894',
    },
    // Pushes the logos to the card bottom, at least 32px under the features.
    logosWrap: {
      marginTop: 'auto',
      paddingTop: 32,
    },
    logosBlock: {
      paddingTop: 20,
      borderTop: '1px solid #F1F3F5',
    },
    logosLabel: {
      color: '#637381',
      fontFamily: 'Inter',
      fontSize: '12px',
      fontWeight: 600,
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
    },
    logosGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
      gap: '12px 20px',
      listStyle: 'none',
      padding: 0,
      margin: '12px 0 0',
      '@media (max-width: 600px)': {
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
      },
    },
    logoCell: {
      display: 'flex',
      alignItems: 'center',
      height: 40,
    },
    logo: {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
      objectPosition: 'left center',
      opacity: 0.6,
      filter: 'grayscale(1)',
    },
    itemTitle: {
      color: '#002E47',
      fontWeight: 600,
    },
  }
}

export default styles
